<div class="panes-wrap" [class.mobile]="isMobile" [class.content-page]="utilsService.isContentPage">
  <ng-container *ngIf="contentFilter?.item; else collectionsTemplate">
    <div class="row breadcrumbs">
      <app-breadcrumbs pageType="content" displayMode="breadCrumbsOnly"></app-breadcrumbs>
    </div>

    <ng-container [ngSwitch]="contentFilter?.baseRoute">
      <app-content-page *ngSwitchCase="'lessons'"></app-content-page>
      <app-meeting-page *ngSwitchCase="'classes'"></app-meeting-page>
      <app-collection-page *ngSwitchCase="'collections'"></app-collection-page>
    </ng-container>
  </ng-container>

  <!-- -->
  <ng-template #collectionsTemplate>
    <ng-container *ngIf="!loading">
      <div *ngIf="isNewsHeader; else universalHeaderTemplate" class="header-wrap">
        <app-main-header></app-main-header>
      </div>

      <ng-template #universalHeaderTemplate>
        <div class="row">
          <app-library-header-new *ngIf="utilsService.isContentPage && !isMobile; else nonContentHeaderTemplate">
          </app-library-header-new>
          <ng-template #nonContentHeaderTemplate>
            <app-library-header></app-library-header>
          </ng-template>
        </div>
      </ng-template>
    </ng-container>

    <ng-container>
      <div class="panes view__panes--default" [class.mobile]="isMobile" [class.tablet]="deviceService.isTablet()">
        <section>
          <ng-container #panesHost></ng-container>
        </section>
      </div>
    </ng-container>

    <ng-container *ngIf="showNotFound">
      <app-filter-cleaning [filterData]="contentFilter"></app-filter-cleaning>
    </ng-container>
  </ng-template>
</div>
